<template>
    <li class="file-item">
        <a :href="'/' + attachment" target="_blank">{{ attachment.split('/').reverse()[0] }}</a>
        <button class="btn remove" @click="remove(index)" type="button">
            <svg enable-background="new 0 0 515.556 515.556" viewBox="0 0 515.556 515.556" xmlns="http://www.w3.org/2000/svg"><path d="m64.444 451.111c0 35.526 28.902 64.444 64.444 64.444h257.778c35.542 0 64.444-28.918 64.444-64.444v-322.222h-386.666z"/><path d="m322.222 32.222v-32.222h-128.889v32.222h-161.111v64.444h451.111v-64.444z"/></svg>
        </button>
    </li>
</template>

<script>
export default {
    props: {
        attachment: {
            type: String,
            required: true,
            default: 'file.jpg'
        }
    }
}
</script>

<style lang="scss">
    .file-item {
        list-style: none;
        
        .btn.remove {
            background: transparent;
            border: none;
            outline: none;

            svg {
                width: 18px;

                path {
                    fill: #e74c3c;
                }
            }


            &:hover {
                cursor: pointer;

                path {
                    fill: #c0392b;
                }
            }
        }
    }
</style>